import React from 'react';
import { useParams } from 'react-router-dom';

import { OfferConfigurePageContainer } from '@occc-app/offerHelpers/components/OfferConfigurePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useChainId } from '@occc-app/Chain/hooks';
import { getCreatePageLinks, useGetCampaignName } from '@occc-app/routes/CampaignComponents/utils';

import { SweepstakesConfigureFormContainer } from '../SweepstakesConfigureFormContainer';
import { messages } from '../messages';
import { getTargetTabProps } from '../utils';

export const SweepstakesConfigurePageContainer: React.FC = () => {
  const { id: campaignId = '', sweepstakesId = '' } = useParams<{
    id: string;
    sweepstakesId: string;
  }>();

  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);

  return (
    <OfferConfigurePageContainer
      campaignId={campaignId}
      offerId={sweepstakesId}
      getBreadcrumbLinks={(offerName) => getCreatePageLinks(campaignId, campaignName, offerName)}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.Sweepstakes}
      targetTabProps={getTargetTabProps}
      ConfigureFormContainer={SweepstakesConfigureFormContainer}
    />
  );
};
